<script setup>
import { computed, ref, watch } from 'vue';
import { LogOut, UserRound } from "lucide-vue-next";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import Profile from '@/components/Profile.vue';
import { clearAssignmentScopeSessionOverrides } from '@/utils/globals';

const props = defineProps({
  user: { type: Object, required: true },
  customer: { type: Object, required: false, default: null },
});

import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const environment = document.documentElement.dataset.env || "";
const showEnvUserDebug = ["development", "staging"].includes(environment);
const profileOpen = ref(false);
const profileUser = ref({ ...props.user });

watch(() => props.user, (user) => {
  profileUser.value = { ...user };
});

function handleProfileSaved(user) {
  profileUser.value = { ...profileUser.value, ...user };
}

const roleNames = computed(() => (props.user?.role_names || []).join(", "));
const functionNames = computed(() => (props.user?.function_names || []).join(", "));
const customerName = computed(
  () =>
    props.user?.customer_name ||
    props.user?.Kunde?.Kunde ||
    props.user?.kunde?.Kunde ||
    props.customer?.Kunde ||
    "-"
);
</script>

<template>
  <SidebarMenu>
	<SidebarMenuItem v-if="showEnvUserDebug" class="mb-2 px-2 text-xs text-muted-foreground">
		<div class="font-medium text-foreground break-all pb-2">{{ props.user?.firstname + " " + props.user?.lastname || "-" }}</div>
		<div><p class="font-bold">Kunde:</p> {{ customerName }}</div>
		<div><p class="font-bold">Rollen:</p> {{ roleNames || "-" }}</div>
		<div><p class="font-bold">Funktionen:</p> {{ functionNames || "-" }}</div>
	</SidebarMenuItem>
	<SidebarMenuItem>
		<SidebarMenuButton @click="profileOpen = true">
			<UserRound />
			<span>Profil</span>
		</SidebarMenuButton>
	</SidebarMenuItem>
	<SidebarMenuItem>
		<SidebarMenuButton>	
			<LogOut />
			<a href="/logout" @click="clearAssignmentScopeSessionOverrides"> {{ t('view.logout') }}</a>
			
		</SidebarMenuButton>
	  </SidebarMenuItem>
  </SidebarMenu>

  <Sheet v-model:open="profileOpen">
    <SheetContent side="right" class="z-[10003] w-full overflow-y-auto sm:max-w-2xl" overlay-class="z-[10002]">
      <SheetHeader class="mb-6">
        <SheetTitle>Profil</SheetTitle>
      </SheetHeader>
      <Profile
        :initialUser="profileUser"
        :impersonating="Boolean(profileUser?.is_impersonating)"
        embedded
        @profile-saved="handleProfileSaved"
      />
    </SheetContent>
  </Sheet>
</template>
